export default __webpack_public_path__ + "static/media/react-icon.503f4b2f.svg";